import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Col, Row, Button, Form } from "react-bootstrap";
import MyNavbar from "../component/navbar";
import logo from "../assets/images/logo_large.svg";
import isEmpty from "is-empty";
import { toastAlert } from "../helper/toastAlert"
import { Roller } from "react-awesome-spinners";
import { forgotpassword } from "../ApiAction/api"
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  forgotValidate, forgotInputValidate
} from "../validation/validation"


let initialValue = {
  email: "",
};
export default function ForgotPassword(props) {

  const [forgotData, setForgotData] = useState(initialValue)
  const [error, setError] = useState({})
  const [isLoad, setisLoad] = useState(false)


  let { email } = forgotData;

  var navigate = useNavigate()

  //forgot password
  let forgotChange = (e) => {
    let { name, value } = e.target;
    var resetData = { ...forgotData, ...{ [name]: value } };
    delete error[name];
    setForgotData(resetData);
    let errMsg = forgotInputValidate(resetData, name);
    //setError({ ...error, ...errMsg });
  };

  let forgotClick = async () => {
    try {
      let errMsg = await forgotValidate(forgotData);
      setError(errMsg);
      if (isEmpty(errMsg)) {
        setisLoad(true);
        let { status, message } = await forgotpassword(forgotData);
        if (status == true) {
          setisLoad(false);
          toastAlert("success", message, "forget");
          setForgotData(initialValue);
        } else {
          setisLoad(false);
          toastAlert("error", message, "forget");
          // setTimeout(() => {
          //   navigate('/login')
          // }, 100);
          setForgotData(initialValue);
        }
      }
    } catch (err) {
      console.log(err, "errr");
    }
  };

  console.log(forgotData, 'forgotData')

  return (
    <>
      <MyNavbar />
      <section>
        <Container>
          <div className="join_sec">
            <Row>
              <Col xl="5">
                <div className="reg_form">
                  <p className="join_head">Forgot Password</p>
                  <Form.Label className="input_join" htmlFor="inputPassword5">
                    Email / Phone Number
                    {/* Email */}
                  </Form.Label>
                  <Form.Control
                    className="input_text"
                    type="text"
                    id="inputPassword5"
                    placeholder="Enter your email or Phone number"
                    //placeholder="Enter your email"
                    name="email"
                    value={email}
                    onChange={forgotChange}
                    aria-describedby="passwordHelpBlock"
                  />
                  {error && error.email && (
                    <span style={{ color: "red" }}>{error.email}</span>
                  )}
                  <p className="link_tag">
                    Remember your password ?<a href="/login"> Login Here!</a>
                  </p>

                  <Button className="nav_btn mx-auto d-block mt-5" onClick={() => forgotClick()}>
                    Submit{isLoad && <i className="fas fa-spinner fa-spin"></i>}
                  </Button>
                </div>
              </Col>
              <Col xl="7" className="d-none  d-xl-block">
                <div className="text-center">
                  <img src={logo} alt="img" className="img-fluid mx-auto " />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
}
